import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiZap, FiPlay } = FiIcons;

export default function HomeHero() {
  return (
    <section className="relative pt-20 pb-12 lg:pt-32 lg:pb-32 overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-indigo-500/10 blur-[120px] rounded-full" />
        <div className="absolute bottom-[10%] right-[-5%] w-[30%] h-[30%] bg-blue-500/10 blur-[120px] rounded-full" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center text-center lg:text-left">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
          >
            <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-indigo-400 text-xs font-black uppercase tracking-widest mb-8">
              <SafeIcon icon={FiZap} className="w-3 h-3" />
              <span>Version 2.0 is live</span>
            </div>

            <h1 className="text-6xl lg:text-8xl font-black text-white mb-8 leading-[0.9] tracking-tighter">
              Build in public,<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-slate-400 via-white to-slate-500">
                zero friction.
              </span>
            </h1>

            <p className="text-xl text-slate-400 mb-12 max-w-xl mx-auto lg:mx-0 font-medium leading-relaxed">
              Your work, automatically documented into a beautiful narrative page. The proof of work platform for elite builders.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link to="/auth" className="btn btn-primary px-10 py-5 flex items-center justify-center space-x-3">
                <span>Start building</span>
                <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
              </Link>
              <button className="btn btn-secondary px-10 py-5 flex items-center justify-center space-x-3">
                <SafeIcon icon={FiPlay} className="w-4 h-4" />
                <span>Watch Demo</span>
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9, rotate: 2 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="relative"
          >
            <div className="absolute inset-0 bg-indigo-500/20 blur-[100px] rounded-full" />
            <div className="relative bg-white/5 border border-white/20 p-2 rounded-[2.5rem] overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&q=80&w=1200" 
                alt="Product Dashboard" 
                className="rounded-[1.8rem] w-full shadow-inner opacity-90"
              />
              <div className="absolute bottom-6 left-6 right-6 p-5 bg-slate-950/90 backdrop-blur-xl rounded-2xl border border-white/10 shadow-2xl">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                    <span className="text-[10px] font-black uppercase tracking-widest text-white">Live: API Refactor Session</span>
                  </div>
                  <span className="text-[10px] font-bold text-slate-500">1h 24m</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}